import React from "react";
import { Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import VideoView from './components/VideoView';
import PaymentPage from './components/PaymentPage';
import MyAnimations from './components/MyAnimations';
import AdminPanel from './components/AdminPanel';
import "./App.css";

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/video/:videoId" element={<VideoView />} />
      <Route path="/payment" element={<PaymentPage />} />
      <Route path="/my-animations" element={<MyAnimations />} />
      <Route path="/admin" element={<AdminPanel />} />
    </Routes>
  );
}

export default App;
